export const permissions = {
  Dashboard: {
    view: true
  },
  Calendar: {
    view: true
  },
  Event: {
    view: true,
    create: false,
    update: false,
    delete: false,
    management: true,
    url: 'events'
  },
  CheckIn: {
    view: true,
    label: 'Check In'
  },
  Customer: {
    view: true,
    create: false,
    update: false,
    delete: false,
    management: true,
    url: 'customers'
  },
  EventType: {
    view: true,
    create: false,
    update: false,
    delete: false,
    management: true,
    url: 'event-types',
    label: 'Event Type'
  },
  ServiceCategory: {
    view: true,
    create: false,
    update: false,
    delete: false,
    management: true,
    url: 'service-categories',
    label: 'Product Category'
  },
  Log: {
    view: true,
    management: true,
    url: 'logs'
  },
  Organizer: {
    view: true,
    create: false,
    update: false,
    delete: false,
    management: true,
    url: 'organizers'
  },
  RateManagement: {
    view: true,
    create: false,
    update: false,
    delete: false,
    management: true,
    url: 'rate-management',
    label: 'Rate Management'
  },
  Order: {
    view: true,
    create: false,
    update: false,
    delete: false,
    management: true,
    url: 'order'
  },
  Payment: {
    view: true,
    create: false,
    update: false,
    delete: false,
    management: true,
    url: 'payments'
  },
  StaffGroup: {
    view: true,
    create: false,
    update: false,
    delete: false,
    management: true,
    url: 'staff-groups',
    label: 'Staff Group'
  },
  Staff: {
    view: true,
    create: false,
    update: false,
    delete: false,
    management: true,
    url: 'staff'
  },
  Settings: {
    view: true,
    create: false,
    update: false,
    delete: false,
    management: true,
    url: 'user-settings'
  },
  SeatTemplate: {
    view: true,
    create: false,
    update: false,
    delete: false,
    management: true,
    url: 'seat-template',
    label: 'Seat Template'
  },
  SeatType: {
    // TODO Rename to SeatTemplateType
    view: true,
    create: false,
    update: false,
    delete: false,
    management: true,
    url: 'seat-template-types',
    label: 'Seat Template Type'
  },
  ClosedDateManagement: {
    view: true,
    create: false,
    update: false,
    delete: false,
    management: true,
    url: 'closed-date-management',
    label: 'Closed Date Management'
  },
  Ticket: {
    view: true,
    create: false,
    update: false,
    delete: false,
    refund: false,
    management: true,
    url: 'ticket-manager'
  },
  TicketType: {
    view: true,
    create: false,
    update: false,
    delete: false,
    management: true,
    url: 'ticket',
    label: 'Ticket Type'
  },
  CustomerGroup: {
    view: true,
    create: false,
    update: false,
    delete: false,
    management: true,
    url: 'customer-groups',
    label: 'Customer Group'
  }
};

export enum AccessPages {
    DASHBOARD = 'Dashboard',
    CALENDAR = 'Calendar',
    SEATTEMPLATE = 'SeatTemplate',
    SEATTYPE = 'SeatType',
    CLOSEDDATEMANAGEMENT = 'ClosedDateManagement',
    TICKET = 'Ticket',
    TICKETTYPE = 'TicketType',
    FAMILYTICKET = 'FamilyTicket',
    CUSTOMER = 'Customer',
    CUSTOMERGROUP = 'CustomerGroup',
    EVENT = 'Event',
    EVENTSERIES = 'EventSeries',
    EVENTTYPE = 'EventType',
    CHECKIN = 'CheckIn',
    ORDER = 'Order',
    ORGANIZER = 'Organizer',
    RATEMANAGEMENT = 'RateManagement',
    PAYMENT = 'Payment',
    STAFFGROUP = 'StaffGroup',
    STAFF = 'Staff',
    SETTINGS = 'Settings',
    SERVICECATEGORY = 'ServiceCategory',
    SERVICE = 'Service',
    LOG = 'Log',
    USER = "User"
}

export enum Actions {
    VIEW = 'view',
    CREATE = 'create',
    DELETE = 'delete',
    UPDATE = 'update',
    REFUND = 'refund',
    MANAGEMENT = 'management',
}
